import useDebouncing from "../../../../utils/useDebouncing"

/**
 * 
 * @param {Array<string>} events
 * @param {Node} node 
 * @param {() => void} fn 
 */
const useAddEvent = (events = [], node, fn) => {
    
    events.forEach((ev) => {
        node.addEventListener(ev, fn)
    })

    const detachEvent = () => {
        events.forEach((ev) => {
            node.removeEventListener(ev, fn)
        })
    }

    return detachEvent;
}

export default useAddEvent;